import { useContext } from 'react';

import { SchoolContext } from '../context/SchoolContext';

export const useSchool = () => useContext(SchoolContext);
